export default __webpack_public_path__ + "static/3-7-0-0-398f223b15c5101d5822de4d03479371.jpg";